<template>
    <div class="container bng-narrow-container bng-messages">
        <template v-if="messages.length">
            <article
                v-for="message in messages"
                :key="message.id"
                class="message"
            >
                <div class="message-body">
                    <p>
                        {{ message.created | localDatetime("") }} - 
                        {{`components.pages.messages.${message.type}.message` | translate}}
                        <span
                            v-if="message.amount && message.currency"
                        >{{message.amount | currency(message.currency)}}</span>
                    </p>
                </div>
            </article>

            <a
                v-if="hasLoadMore"
                class="button is-info is-rounded is-fullwidth"
                :class="{ 'is-loading': loading }"
                @click="loadMore();"
            >{{ "components.pages.messages.load more" | translate }}</a>
        </template>
        <template v-else>
            <div class="empty">{{"components.pages.messages.no messages" | translate}}</div>
        </template>
    </div>
</template>

<script>
import pushService from '../../../../../../_common/services/push.service';

export default {
    name: 'profile-messages',
    data() {
        return {
            init: false,
            loading: false,
            take: 10,
            skip: 0,
            messages: [],
            hasLoadMore: true
        };
    },
    async created() {
        await this.refresh();
        setTimeout(() => {
            this.setAllRead();
        }, 1000);
    },
    methods: {
        async refresh() {
            this.loading = true;
            this.skip = 0;
            this.messages.length = 0;
            let newMessages = await pushService.get(this.take, this.skip);
            this.hasLoadMore = newMessages.length >= this.take;
            this.messages.push(...newMessages);

            this.loading = false;
        },
        async loadMore() {
            this.loading = true;
            this.skip += this.take;
            let newMessages = await pushService.get(this.take, this.skip);
            this.hasLoadMore = newMessages.length >= this.take;
            this.messages.push(...newMessages);
            this.loading = false;
        },
        async setAllRead() {
            if (this.messages) {
                pushService.setAllRead();
            }
        }
    }
};
</script>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/pages/sitepages/messages/messages.vue